@if (gridView$ | async; as view) {
  <div class="pages-container w-screen h-screen flex">
    @if (view !== "medium" && view !== "small") {
      <div class="pages-side-menu-bar no-print">
        <st-side-menu-bar
          [settingURL]="configurations().settingRoute"
          [profile]="configurations().profile"
          [isProfilePage]="configurations().isProfileRoute ?? false"
          [navigationList]="navigationList"
          [homeButton]="configurations().homeButton"
          [tools]="tools()"
        ></st-side-menu-bar>
      </div>
      <div class="pages-side-menu">
        <st-side-menu [logoUrl]="configurations().logoUrl"></st-side-menu>
      </div>
    }
    <main class="flex flex-column flex-1 overflow-hidden">
      <div class="pages-top-header no-print">
        <st-top-header [logoUrl]="configurations().logoUrl">
          @if (
            configurations().hasNotificationSection &&
            view !== "medium" &&
            view !== "small"
          ) {
            <div
              ngProjectAs="top-header-notification-section"
              class="flex align-items-center"
            >
              <ng-content select="notification-section-template"></ng-content>
              <button
                class="filters-menu-toggle"
                [ngClass]="{ active: isFiltersMenuOpened() }"
                (click)="expandFilters()"
              >
                <em class="icon-list"></em>
              </button>
            </div>
          }
          @if (
            configurations().hasHeaderFilters &&
            view !== "medium" &&
            view !== "small"
          ) {
            <div ngProjectAs="top-header-filters-section">
              <st-bc-top-header-filters
                [regions]="regions()"
                [locations]="locations()"
                [(selectedLocations)]="selectedLocations"
                [(selectedRegions)]="selectedRegions"
                (locationsFilters)="filter($event)"
              ></st-bc-top-header-filters>
            </div>
          }
        </st-top-header>
      </div>
      <div class="main-section flex flex-1 h-full overflow-auto">
        @if (view === "medium" || view === "small") {
          <st-side-menu-drawer
            [settingURL]="configurations().settingRoute"
            [profile]="configurations().profile"
            [navigationList]="navigationList"
            [homeButton]="configurations().homeButton"
            [tools]="tools()"
            [maxWidth]="'260px'"
            class="st-side-menu-drawer"
          ></st-side-menu-drawer>
        }
        <div class="pages-content flex-1 h-full overflow-auto">
          <ng-content select="page-content"></ng-content>
        </div>
        @if (view === "medium" || view === "small") {
          @if (configurations().hasHeaderFilters) {
            <st-mobile-right-menu class="ml-auto no-print" [maxWidth]="'260px'">
              <div
                ngProjectAs="top-header-filters-section-mobile"
                class="h-full"
              >
                <st-mobile-header-filters
                  [regions]="regions()"
                  [locations]="locations()"
                  [(selectedLocations)]="selectedLocations"
                  [(selectedRegions)]="selectedRegions"
                  (locationsFilters)="filter($event)"
                ></st-mobile-header-filters>
              </div>
            </st-mobile-right-menu>
          }
        }
      </div>
    </main>
  </div>
}

@if (isAboutModalVisible()) {
  <app-about-modal-component
    [isDialogVisible]="isAboutModalVisible()"
    (hide)="closeAboutModal()"
  ></app-about-modal-component>
}
